export default __webpack_public_path__ + "static/media/messaging1.2e539ff5.jpg";